import { StoreComponent, StorageDialogComponent} from '../store/store.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataService } from '../services/data.service';
import { BudgetListComponent } from './budget-list.component';
import { BudgetDetailComponent, ContactPickerDialogComponent, OpenProjectDialogComponent, DocumentEditorDialogComponent, ArchiveProjectDialogComponent } from './budget-detail.component';
import { SubBudgetComponent, MaterialDialogComponent } from './sub-budget.component';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SubBudgetFormComponent } from './components/sub-budget-form.component';
import { MaterialFormComponent } from './components/material-form.component';
import { MarginFormComponent } from './components/margin-form.component';
import { SharedModule } from '../shared/shared.module';
import { ShippingFormComponent } from './components/shipping-form.component';
import { AssemblyCostsFormComponent } from './components/assemblyCosts-form.component';
import { ExportFormComponent } from './components/export-form.component';
import { RouterModule } from '@angular/router';
import { BudgetGuard } from './guards/budget.guard';
import { SummaryChartComponent } from './components/summary-chart/summary-chart.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BudgetService } from '../services/budget.service';


@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxChartsModule
  ],
  declarations: [
    BudgetListComponent,
    BudgetDetailComponent,
    SubBudgetComponent,
    SubBudgetFormComponent,
    ContactPickerDialogComponent,
    OpenProjectDialogComponent,
    ArchiveProjectDialogComponent,
    DocumentEditorDialogComponent,
    MaterialFormComponent,
    MaterialDialogComponent,
    //StorageDialogComponent,
    MarginFormComponent,
    ShippingFormComponent,
    AssemblyCostsFormComponent,
    ExportFormComponent,
    SummaryChartComponent
    //StoreComponent
  ],
  entryComponents: [ContactPickerDialogComponent,
    DocumentEditorDialogComponent,
    OpenProjectDialogComponent,
    ArchiveProjectDialogComponent,
    MaterialDialogComponent], // https://angular.io/guide/ngmodule-faq#why-does-angular-need-entrycomponents
  providers: [DataService, BudgetGuard]
})
export class BudgetModule { }



// WEBPACK FOOTER //
// ./src/app/budget/budget.module.ts